import { createSlice } from "@reduxjs/toolkit";
import {
  createBulkLegacyContract,
  deleteDuplicatesContracts,
  editHistoricalContracts,
  extractMetaDataWithAI,
  FindMissingContract,
  getAssignTasktoLegalAssociates,
  getBufferDataFromUrl,
  getBulkAssignedData,
  getBulkAssignTasktoLegalAssociates,
  getBulkReAssignTasktoLegalAssociates,
  getContractsByInstanceId,
  getDistributedContractDetails,
  getDuplicatesContractLists,
  getImportsDetailsById,
  getLegacyImportList,
  getLegalAssociates,
  getTokenforGoogledrive,
  Sendfilesandfolder,
  unassignandReassignContractToLegalAssociate,
  updateMetaDataThrouCSV,
} from "./LegacyImports.Action";
const initialState = {
  legacyImportList: [{}],
  LegacyImportListPagination: {
    total: 0,
    pageSize: 20,
    defaultCurrent: 1,
    current: 1,
    sortBy: "DESC",
    showSizeChanger: true,
    search: "",
    orderBy: "createdAt",
  },
  instanceDrawerVisible: false,
  instanceDrawerRecord: {},
  contractsByInstanceIdPagination: {
    total: 0,
    pageSize: 20,
    defaultCurrent: 1,
    current: 1,
    sortBy: "DESC",
    showSizeChanger: true,
    search: "",
    orderBy: "createdAt",
  },
  contractsByInstanceIdList: [],
  distributedContractDetails: {},
  isUploadContratsModalVisible: false,
  isFillAndUpdateContractsDrawerVisible: false,
  FillAndUpdateContractsDrawerRecord: {},
  contractpdfurl: "",
  metaDataFields: [],
  legacyImportListLoading: false,
  isMetaDataExtracting: false,
  isEditingContract: false,
  googleDriveData: {},
  isRemoveDuplicatesModalVisible: false,
  isDuplicateContractsLoading: false,
  duplicateContractsLists: [],
  isDeletingDuplicates: false,
  isLegalAssociateFilterModalVisible: false,
  legalAssociatesList: [],
  isLegalAssociatesLoading: false,
  isLegalAssociateFilterApplied: false,
  LegalAssociateFilterPaginationData: {},
  isBulkAssignModalVisible: false,
  isBulkAssigningTask: false,
  selectedTasksIds: [],
  isAssignandReassignModalVisible: false,
  assignModalRecord: {},
  assignModalType: "",
  isAssignTasktoLegalAssociatesLoading: false,
  contractsByInstanceIdLoading: false,
  isMetadataInfoModalVisible: false,
  isCheckBulkUploadModalVisible: false,
  BulkuploadRecord: {},
  isUpdatingMetaDataByCSV: false,
  FillAndUpdateContractsDrawerType: "",
  viewMissingContractModalVisible: false,
  MissingContractModalRecord: {},
  isViewMode :false,
  importDetailsLoading:false,
  
};
export const LegacyImportsSlice = createSlice({
  name: "legacyImports",
  initialState,
  reducers: {
    setLegacyImportsData: (state, action) => {
      state.legacyImportList = action.payload;
    },
    setInstanceDrawerVisible: (state, { payload }) => {
      state.instanceDrawerVisible = payload?.visible;
      state.instanceDrawerRecord = payload?.record || {};
    },
    setUploadContratsModalVisible: (state, { payload }) => {
      state.isUploadContratsModalVisible = payload?.visible;
    },
    setFillAndUpdateContractsDrawerVisible: (state, { payload }) => {
      state.isFillAndUpdateContractsDrawerVisible = payload?.visible;
      state.FillAndUpdateContractsDrawerRecord = payload?.record || {};
      state.metaDataFields = payload?.record?.dynamicParameters || [];
      state.FillAndUpdateContractsDrawerType = payload?.type || "";
      state.isViewMode = payload?.view || false;
    },
    onMetaDataValueChange: (state, { payload }) => {
      const { fieldName, value, UniqueId } = payload;
      console.log("UniqueId", UniqueId);
      console.log("fieldName", payload);
      const updatedMetaDataFields = state.metaDataFields.map((field) => {
        if (field._id === UniqueId) {
          return { ...field, value: value };
        }
        return field;
      });
      state.metaDataFields = updatedMetaDataFields;
    },
    onPageChangesFilter: (state, action) => {
      state.LegacyImportListPagination = {
        ...state.LegacyImportListPagination,
        current: action.payload.current,
        pageSize: action.payload.pageSize,
        sortBy: action.payload.order === 1 ? "ASC" : "DESC",
        search: action.payload.search,
        orderBy: action.payload.orderBy,
      };
    },
    removeDuplicatesModalVisible: (state, { payload }) => {
      state.isRemoveDuplicatesModalVisible = payload?.visible;
    },
    setLegalAssociateFilterModalVisible: (state, { payload }) => {
      state.isLegalAssociateFilterModalVisible = payload?.visible;
    },
    setLegalAssociateFilterApplied: (state, { payload }) => {
      state.isLegalAssociateFilterApplied = payload;
    },
    setLegalAssociateFilterPaginationData: (state, { payload }) => {
      state.LegalAssociateFilterPaginationData = payload;
    },
    setBulkAssignModalVisible: (state, { payload }) => {
      state.isBulkAssignModalVisible = payload?.visible;
    },
    setSelectedTasksIds: (state, { payload }) => {
      state.selectedTasksIds = payload;
    },
    setAssignandReassignModalVisible: (state, { payload }) => {
      state.isAssignandReassignModalVisible = payload.visible || false;
      state.assignModalType = payload.type || "";
      state.assignModalRecord = payload.record || {};

      if (!payload.visible) {
        state.assignModalRecord = {};
        state.assignModalType = "";
      }
    },
    setMetadataInfoModalVisible: (state, { payload }) => {
      state.isMetadataInfoModalVisible = payload.visible;
    },
    setCheckBulkUploadModalVisible: (state, { payload }) => {
      state.isCheckBulkUploadModalVisible = payload?.visible;
      state.BulkuploadRecord = payload?.record || {};
    },
    setUploadMetaDrawerVisible: (state, { payload }) => {
      state.isUploadMetaDrawerVisible = payload?.visible;
      state.UploadMetaDrawerRecord = payload?.record || {};
    },
    setViewMissingContractModalVisible: (state, { payload }) => {
      state.viewMissingContractModalVisible = payload?.visible || false;
      state.MissingContractModalRecord = payload?.record || {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLegacyImportList.pending, (state) => {
        // You can set a loading state here if needed
        state.legacyImportListLoading = true;
      })
      .addCase(getLegacyImportList.fulfilled, (state, action) => {
        state.legacyImportList = action.payload.data || [];
        state.LegacyImportListPagination = {
          ...state.LegacyImportListPagination,
          total: action.payload.total,
        };
        state.legacyImportListLoading = false;
      })
      .addCase(getLegacyImportList.rejected, (state, action) => {
        state.legacyImportListLoading = false;

        // Handle errors here if needed
      })
      .addCase(getContractsByInstanceId.pending, (state) => {
        // You can set a loading state here if needed
        state.contractsByInstanceIdLoading = true;
      })
      .addCase(getContractsByInstanceId.fulfilled, (state, action) => {
        state.contractsByInstanceIdList = action.payload.data || [];
        state.contractsByInstanceIdPagination = {
          ...state.contractsByInstanceIdPagination,
          total: action.payload.total,
        };
        state.contractsByInstanceIdLoading = false;
      })
      .addCase(getContractsByInstanceId.rejected, (state, action) => {
        // Handle errors here if needed
        state.contractsByInstanceIdLoading = false;
      })
      .addCase(getDistributedContractDetails.pending, (state) => {
        // You can set a loading state here if needed
      })
      .addCase(getDistributedContractDetails.fulfilled, (state, action) => {
        state.distributedContractDetails = action.payload || {};
      })
      .addCase(getDistributedContractDetails.rejected, (state, action) => {
        // Handle errors here if needed
      })
      .addCase(getBufferDataFromUrl.pending, (state, { payload }) => {
        state.contractpdfurl = "";
      })
      .addCase(getBufferDataFromUrl.fulfilled, (state, { payload }) => {
        state.contractpdfurl = payload;
      })
      .addCase(getBufferDataFromUrl.rejected, (state, { payload }) => {
        state.contractpdfurl = "";
      })
      .addCase(extractMetaDataWithAI.pending, (state) => {
        state.isMetaDataExtracting = true;
      })
      .addCase(extractMetaDataWithAI.fulfilled, (state, { payload }) => {
        state.isMetaDataExtracting = false;
        state.FillAndUpdateContractsDrawerRecord =
          payload?.data?.historicalContractDetails || {};
        state.metaDataFields =
          payload?.data?.historicalContractDetails?.dynamicParameters || [];
      })
      .addCase(extractMetaDataWithAI.rejected, (state, { payload }) => {
        state.isMetaDataExtracting = false;
      })
      .addCase(editHistoricalContracts.pending, (state) => {
        // state.isDrawerVisible = false;
        state.isEditingContract = true;
      })
      .addCase(editHistoricalContracts.fulfilled, (state, { payload }) => {
        state.isEditingContract = false;
        state.isFillAndUpdateContractsDrawerVisible = false;
      })
      .addCase(editHistoricalContracts.rejected, (state, { payload }) => {
        state.isEditingContract = false;
      })
      .addCase(createBulkLegacyContract.pending, (state) => {
        state.isCreatingBulkLegacyContract = true;
      })
      .addCase(createBulkLegacyContract.fulfilled, (state, { payload }) => {
        state.isCreatingBulkLegacyContract = false;
        state.isUploadContratsModalVisible = false;
      })
      .addCase(createBulkLegacyContract.rejected, (state, { payload }) => {
        state.isCreatingBulkLegacyContract = false;
      })
      .addCase(getTokenforGoogledrive.pending, (state) => {})
      .addCase(getTokenforGoogledrive.fulfilled, (state, { payload }) => {
        state.googleDriveData = payload?.data;
      })
      .addCase(getTokenforGoogledrive.rejected, (state, { payload }) => {})
      .addCase(Sendfilesandfolder.pending, (state) => {
        state.isCreatingBulkLegacyContract = true;
      })
      .addCase(Sendfilesandfolder.fulfilled, (state, { payload }) => {
        state.googleDriveData = {};
        state.isCreatingBulkLegacyContract = false;
        state.isUploadContratsModalVisible = false;
      })
      .addCase(Sendfilesandfolder.rejected, (state, { payload }) => {
        state.isCreatingBulkLegacyContract = false;
      })
      .addCase(getDuplicatesContractLists.pending, (state) => {
        state.isDuplicateContractsLoading = true;
      })
      .addCase(getDuplicatesContractLists.fulfilled, (state, { payload }) => {
        state.isDuplicateContractsLoading = false;
        state.duplicateContractsLists = payload?.data || [];
      })
      .addCase(getDuplicatesContractLists.rejected, (state, { payload }) => {
        state.isDuplicateContractsLoading = false;
      })
      .addCase(deleteDuplicatesContracts.pending, (state) => {
        state.isDeletingDuplicates = true;
      })
      .addCase(deleteDuplicatesContracts.fulfilled, (state, { payload }) => {
        state.isDeletingDuplicates = false;
        state.isRemoveDuplicatesModalVisible = false;
      })
      .addCase(deleteDuplicatesContracts.rejected, (state, { payload }) => {
        state.isDeletingDuplicates = false;
      })
      .addCase(getLegalAssociates.pending, (state) => {
        state.isLegalAssociatesLoading = true;
      })
      .addCase(getLegalAssociates.fulfilled, (state, { payload }) => {
        state.isLegalAssociatesLoading = false;
        state.legalAssociatesList = payload.data;
      })
      .addCase(getLegalAssociates.rejected, (state, { payload }) => {
        state.isLegalAssociatesLoading = false;
      })
      .addCase(getBulkAssignTasktoLegalAssociates.pending, (state) => {
        state.isBulkAssigningTask = true;
      })
      .addCase(
        getBulkAssignTasktoLegalAssociates.fulfilled,
        (state, { payload }) => {
          state.isBulkAssigningTask = false;
          state.isBulkAssignModalVisible = false;
        }
      )
      .addCase(
        getBulkAssignTasktoLegalAssociates.rejected,
        (state, { payload }) => {
          state.isBulkAssigningTask = false;
        }
      )
      .addCase(getBulkReAssignTasktoLegalAssociates.pending, (state) => {
        state.isBulkAssigningTask = true;
      })
      .addCase(
        getBulkReAssignTasktoLegalAssociates.fulfilled,
        (state, { payload }) => {
          state.isBulkAssigningTask = false;
          state.isBulkAssignModalVisible = false;
        }
      )
      .addCase(
        getBulkReAssignTasktoLegalAssociates.rejected,
        (state, { payload }) => {
          state.isBulkAssigningTask = false;
        }
      )
      .addCase(getAssignTasktoLegalAssociates.pending, (state) => {
        state.isAssignTasktoLegalAssociatesLoading = true;
      })
      .addCase(
        getAssignTasktoLegalAssociates.fulfilled,
        (state, { payload }) => {
          state.isAssignTasktoLegalAssociatesLoading = false;
          state.isAssignandReassignModalVisible = false;
          state.selectedTasksIds = [];
        }
      )
      .addCase(
        getAssignTasktoLegalAssociates.rejected,
        (state, { payload }) => {
          state.isAssignTasktoLegalAssociatesLoading = false;
        }
      )
      .addCase(unassignandReassignContractToLegalAssociate.pending, (state) => {
        state.isAssignTasktoLegalAssociatesLoading = true;
      })
      .addCase(
        unassignandReassignContractToLegalAssociate.fulfilled,
        (state, { payload }) => {
          state.isAssignTasktoLegalAssociatesLoading = false;

          state.isAssignandReassignModalVisible = false;
        }
      )
      .addCase(
        unassignandReassignContractToLegalAssociate.rejected,
        (state, { payload }) => {
          state.isAssignTasktoLegalAssociatesLoading = false;
        }
      )
      .addCase(updateMetaDataThrouCSV.pending, (state) => {
        state.isUpdatingMetaDataByCSV = true;
      })
      .addCase(updateMetaDataThrouCSV.fulfilled, (state, { payload }) => {
        state.isUpdatingMetaDataByCSV = false;
        state.isUploadMetaDrawerVisible = false;
        state.isMetadataInfoModalVisible = false;
      })
      .addCase(updateMetaDataThrouCSV.rejected, (state, { payload }) => {
        state.isUpdatingMetaDataByCSV = false;
      })
      .addCase(getBulkAssignedData.pending, (state) => {})
      .addCase(getBulkAssignedData.fulfilled, (state, { payload }) => {
        state.BulkAssignedData = payload.data;
      })
      .addCase(getBulkAssignedData.rejected, (state, { payload }) => {})
      .addCase(getImportsDetailsById.pending, (state) => {
        state.importDetailsLoading=true;
      })
      .addCase(getImportsDetailsById.fulfilled, (state, { payload }) => {
        state.importDetailsLoading=false;

        state.instanceDrawerRecord = payload?.data || {};
      })
      .addCase(getImportsDetailsById.rejected, (state, { payload }) => {
        state.importDetailsLoading=false;

      })
      .addCase(FindMissingContract.pending, (state) => {
        state.isFindingMissingcontract = true;
        // state.isFindMissingcontractModalVisible = true;
      })
      .addCase(FindMissingContract.fulfilled, (state, { payload }) => {
        // state.isFindMissingcontractModalVisible = true;
        // state.isFindingMissingcontract = false;
      })
      .addCase(FindMissingContract.rejected, (state, { payload }) => {
        state.isFindMissingcontractModalVisible = false;

        state.isFindingMissingcontract = false;
      });
  },
});

export const {
  setLegacyImportsData,
  setInstanceDrawerVisible,
  setUploadContratsModalVisible,
  setFillAndUpdateContractsDrawerVisible,
  onMetaDataValueChange,
  onPageChangesFilter,
  removeDuplicatesModalVisible,
  setLegalAssociateFilterModalVisible,
  setLegalAssociateFilterApplied,
  setLegalAssociateFilterPaginationData,
  setBulkAssignModalVisible,
  setSelectedTasksIds,
  setAssignandReassignModalVisible,
  setMetadataInfoModalVisible,
  setCheckBulkUploadModalVisible,
  setUploadMetaDrawerVisible,
  setViewMissingContractModalVisible,
} = LegacyImportsSlice.actions;
export default LegacyImportsSlice.reducer;
